import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import NavbarComp from '../../shared/components/Navbar';
import { IoAddCircleOutline } from 'react-icons/io5';
import TypeProductTable from './components/TypeProductTable';
import TypeProductAddModal from './components/TypeProductAddModal';
import AlertMessage from '../../shared/components/Alert';
import useTypeProduct from './hooks/useTypeProduct';

const TypeProductPage = () => {

  const {
    typeProduct,
    loading,
    error,
    addTypeProduct,
    editTypeProduct,
    fetchTypeProduct,
    fetchTypeProductById,
    removeTypeProduct,
    updateOnActive,
    alert } = useTypeProduct();

  const [showModal, setShowModal] = useState(false);

  const [editingData, setEditingData] = useState(null);

  const handleOpenModal = (row) => {
    setShowModal(true);
  };

  useEffect(() => {
    fetchTypeProduct();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingData(null);  // Reset after closing
  };

  const handleEditTypeProduct = (updatedTypeProduct) => {
    setEditingData(updatedTypeProduct)
    handleOpenModal(updatedTypeProduct)
  };

  const handleDeleteTypeProduct = (id) => {
    removeTypeProduct(id.id);
  };

  return (
    <>
      <NavbarComp />
      <AlertMessage show={alert.show} variant={alert.variant} message={alert.message} onClose={() => { }} />
      <Container fluid className="mt-2 mt-md-5">
        <Button Tooltip={"test"} variant="outline-success" className="mb-2" onClick={handleOpenModal}>
          <IoAddCircleOutline size={32} />
        </Button>
        <TypeProductTable
          typeProductTables={typeProduct}
          onEdit={handleEditTypeProduct}
          onDelete={handleDeleteTypeProduct}
          updateOnActive={updateOnActive}
        />
        <TypeProductAddModal
          show={showModal}
          handleClose={handleCloseModal}
          handleAddTypeProducts={addTypeProduct}
          parsingDataEdit={editingData}
        />
      </Container>
    </>
  );
};

export default TypeProductPage;
